import LoadingButton from "@mui/lab/LoadingButton";
import {
  Box,
  Button,
  FormControl,
  Grid,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { colors } from "../../Styles/GlobalStyles/Variables";
import { LighterGreenButton } from "../Button/CustomButton";
import Iconify from "../Dashboard/Iconify";
import { StyledDivider } from "../Divider/StyledDivider";
import { continueButtonStyle } from "../MangeSuccessfulBusiness/dialogStyles/DialogStyles";
import NotFoundImage from "../../Assets/NotFound/search-not-found.gif";
const getCMState = (state) => state.usersReducer;

export const LoadingButtonStyle = {
  color: colors.white,
  backgroundColor: colors.primaryGreen,
  textTransform: "inherit",
  fontFamily: Typography.secondaryFont,
  "&:hover": {
    backgroundColor: colors.darkGreen,
  },
};

const FormOne = ({
  activeStep,
  handleBack,
  ToStoryPageHandler,
  isFoundCM,
  formValues,
  findCMHandler,
  stateCodeHandler,
  loadingButton,
  showCM,
  formStates,
  isError,
}) => {
  const { corpsmemberDetails, isLoading } = useSelector(getCMState);
  const exCM = corpsmemberDetails?.data || {};

  return (
    <React.Fragment>
      <Box
        style={{
          padding: "40px 10px 0px 10px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              variant="subtitle2"
              style={{
                fontStyle: "italic",
                color: "#1d1d1d",
                margin: "15px 0px 5px 0px ",
              }}
            >
              Please enter the state code of ex corps member
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                size="small"
                variant="outlined"
                value={formValues.stateCode}
                onChange={(e) => {
                  stateCodeHandler(e);
                }}
                inputProps={{
                  spellCheck: true,
                  lang: "English",
                }}
                error={formStates.inputError}
                helperText={formStates.inputErrorMsg}
              />
            </FormControl>
          </Grid>
          <Grid item xs={3}>
            <FormControl fullWidth>
              <LighterGreenButton
                loading={loadingButton ? true : false}
                fullWidth
                sx={{ padding: "8px", background: "#62AC87" }}
                onClick={findCMHandler}
              >
                <span style={{ marginRight: "10px" }}>Find</span>{" "}
                <Iconify icon="ic:twotone-search" width={20} height={20} />
              </LighterGreenButton>
            </FormControl>
          </Grid>
          {!showCM &&
          !isLoading &&
          exCM !== null &&
          Object.keys(exCM).length > 0 &&
          !isError ? (
            <Grid item xs={12}>
              <Box sx={{ mt: "20px" }}>
                <StyledDivider textAlign="left">
                  <Typography variant="subtitle2" sx={{ color: "#949494" }}>
                    Ex Corps Member Details
                  </Typography>
                </StyledDivider>
                <FormControl fullWidth sx={{ margin: "20px 10px" }}>
                  <TextField
                    id="standard-read-only-input"
                    label="Full Name"
                    value={exCM?.cmName}
                    InputProps={{
                      readOnly: true,
                    }}
                    variant="standard"
                  />
                </FormControl>
                <FormControl sx={{ margin: "20px 10px" }}>
                  <TextField
                    id="standard-read-only-input"
                    label="Course"
                    value={exCM?.course}
                    InputProps={{
                      readOnly: true,
                    }}
                    variant="standard"
                  />
                </FormControl>
                <FormControl sx={{ margin: "20px 10px" }}>
                  <TextField
                    id="standard-read-only-input"
                    label="LGA"
                    value={exCM?.lga}
                    InputProps={{
                      readOnly: true,
                    }}
                    variant="standard"
                  />
                </FormControl>
              </Box>
            </Grid>
          ) : showCM ? (
            <Skeleton
              animation="wave"
              variant="rounded"
              width={500}
              height={200}
              sx={{ margin: "30px 0px 3px 20px" }}
            />
          ) : !isLoading && Object.keys(exCM).length === 0 && !isError ? (
            <Box
              mb={2}
              sx={{ width: "100%", display: "flex", justifyContent: "center" }}
            >
              <div style={{ textAlign: "center", textTransform: "initial" }}>
                <img
                  height={150}
                  width={150}
                  src={NotFoundImage}
                  alt="EX Corps Member not found."
                />
                <Typography variant="body2">
                  Ex Corps Member not found. You may have searched for the wrong
                  <br /> state code. Ensure the state code is correct.
                </Typography>
              </div>
            </Box>
          ) : (
            <Box sx={{ height: "300px" }}></Box>
          )}
        </Grid>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        <Button
          color="inherit"
          disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ mr: 1, textTransform: "capitalize" }}
        >
          Back
        </Button>
        <Box sx={{ flex: "1 1 auto" }} />

        <LoadingButton
          disableElevation
          variant="contained"
          disabled={
            (isLoading === false && Object.keys(exCM).length === 0) ||
            isLoading === true ||
            isError
              ? true
              : false
          }
          onClick={ToStoryPageHandler}
          sx={{ textTransform: "capitalize" }}
        >
          <span style={continueButtonStyle}>
            Continue <Iconify icon="material-symbols:arrow-forward-rounded" />
          </span>
        </LoadingButton>
      </Box>
    </React.Fragment>
  );
};

export default FormOne;
